
















import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ISelectOption from '@frontend/types/base/ISelectOption';
import RadioButton from './components/RadioButton.vue';

@Component({
	components: {
		RadioButton
	}
})
export default class DialRadioGroup extends Vue {
	@Model('input')
	protected readonly checkedValue!: string | null;

	@Prop(String)
	protected readonly name!: string;

	@Prop(Array)
	protected readonly options!: ISelectOption[];

	protected rotationMap = [-45, 45, 135, -135];

	protected get currentIndex(): number {
		return this.options.findIndex((item): boolean => {
			return item.value === this.checkedValue;
		});
	}

	protected get knobRotation(): string {
		const rotation = this.currentIndex ? this.rotationMap[this.currentIndex] : this.rotationMap[0];
		return `transform: rotate(${rotation}deg)`;
	}

	protected get optionsWithProps() {
		return this.options.map(item => {
			return {
				...item,
				name: this.name,
				checkedValue: this.checkedValue
			};
		});
	}

	protected nextOption() {
		const nextValue =
			this.currentIndex + 1 === this.options.length ? this.options[0].value : this.options[this.currentIndex + 1].value;

		this.$emit('input', nextValue);
	}

	protected onChange(value: string): void {
		this.$emit('input', value);
	}
}
